import React from 'react';
import { useEffect, useState } from 'react';
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField
} from '@mui/material';
import { Sidebar } from './Sidebar';

export const UpdateItem = ({ onClose, onSubmit, partners, edit }) => {
  const [externalId, setExternalId] = useState('');
  const [active, setActive] = useState<Boolean>();
  const [partnerName, setPartnerName] = useState('');

  useEffect(() => {
    if (edit && partners) {
      const editPartner = partners[0];
      setPartnerName(editPartner.partnerName);
      setActive(editPartner.active);
      setExternalId(editPartner.externalId);
    }
  }, []);

  const submit = async () => {
    try {
      onSubmit({
        active,
        partnerName,
        externalId
      });
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <Sidebar
      title={edit ? 'Edit Partner' : 'Add Partner'}
      onClose={onClose}
      onDone={submit}>
      <div style={{ height: '81%', overflowY: 'auto' }}>
        <FormControl fullWidth variant="standard">
          <TextField
            placeholder="Partner Name"
            fullWidth
            style={{ padding: 20, marginTop: 30 }}
            value={partnerName}
            onChange={evt => {
              setPartnerName(evt.target.value);
            }}
          />
        </FormControl>
        <FormControl fullWidth variant="standard">
          <TextField
            placeholder="External ID"
            fullWidth
            style={{ padding: 20 }}
            value={externalId}
            onChange={evt => {
              setExternalId(evt.target.value);
            }}
          />
        </FormControl>

        <FormControl fullWidth variant="standard" style={{ padding: 20 }}>
          <InputLabel
            style={{
              paddingTop: 20,
              paddingRight: 20,
              paddingBottom: 20,
              paddingLeft: 30
            }}>
            Active?
          </InputLabel>
          <Select
            value={active}
            onChange={evt => {
              setActive(evt.target.value as any);
            }}>
            <MenuItem value={true as any}>True</MenuItem>
            <MenuItem value={false as any}>False</MenuItem>
          </Select>
        </FormControl>
      </div>
    </Sidebar>
  );
};
